export const parseSpotifyEmbed = (url) => {
  try {
    const u = new URL(url.trim());
    if (!u.hostname.includes('spotify.com')) return null;
    const m = u.pathname.match(/^\/(playlist|album|track|artist|episode|show)\/([a-zA-Z0-9]+)/);
    if (!m) return null;
    return `https://open.spotify.com/embed/${m[1]}/${m[2]}?utm_source=generator&theme=0`;
  } catch { return null; }
};

const ytOriginParam = () => {
  try {
    if (typeof window === 'undefined') return '';
    const o = encodeURIComponent(window.location.origin);
    return o ? `&origin=${o}` : '';
  } catch {
    return '';
  }
};

export const parseYouTubeEmbed = (url) => {
  try {
    const u = new URL(url.trim());
    const api = `enablejsapi=1${ytOriginParam()}`;
    const base = `${api}&rel=0&modestbranding=1&color=white&iv_load_policy=3`;
    if (u.hostname === 'youtu.be') {
      const id = u.pathname.slice(1).split('/')[0];
      if (!id) return null;
      const list = u.searchParams.get('list');
      return `https://www.youtube.com/embed/${id}?${base}${list ? `&list=${list}` : ''}`;
    }
    if (u.hostname.includes('youtube.com')) {
      const sm = u.pathname.match(/^\/shorts\/([a-zA-Z0-9_-]+)/);
      if (sm) return `https://www.youtube.com/embed/${sm[1]}?${base}`;
      const v = u.searchParams.get('v');
      const list = u.searchParams.get('list');
      if (list && !v) return `https://www.youtube.com/embed/videoseries?list=${list}&${base}`;
      if (v) return `https://www.youtube.com/embed/${v}?${base}${list ? `&list=${list}` : ''}`;
    }
    return null;
  } catch { return null; }
};

/**
 * Params for YT.Player (IFrame API). Aligns with parseYouTubeEmbed acceptance rules.
 * @returns {{ videoId: string | null, listId: string | null } | null}
 */
export const parseYouTubePlayerParams = (url) => {
  try {
    const u = new URL(url.trim());
    if (u.hostname === 'youtu.be') {
      const id = u.pathname.slice(1).split('/')[0]?.replace(/[^a-zA-Z0-9_-]/g, '') || '';
      if (!id) return null;
      const list = u.searchParams.get('list');
      return { videoId: id, listId: list && /^[a-zA-Z0-9_-]+$/.test(list) ? list : null };
    }
    if (u.hostname.includes('youtube.com')) {
      const shorts = u.pathname.match(/^\/shorts\/([a-zA-Z0-9_-]{8,})/);
      if (shorts) return { videoId: shorts[1], listId: null };
      const v = u.searchParams.get('v');
      const list = u.searchParams.get('list');
      const vid = v && /^[a-zA-Z0-9_-]{8,}$/.test(v) ? v : null;
      const lid = list && /^[a-zA-Z0-9_-]+$/.test(list) ? list : null;
      if (lid && !vid) return { videoId: null, listId: lid };
      if (vid) return { videoId: vid, listId: lid };
    }
    return null;
  } catch {
    return null;
  }
};

/** @param {string | null} videoId */
export const getYouTubeThumbnailUrl = (videoId) =>
  videoId ? `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg` : null;

export const detectUrlType = (url) => {
  if (!url || !url.trim()) return 'empty';
  try {
    const u = new URL(url.trim());
    if (u.hostname.includes('spotify.com')) return 'spotify';
    if (u.hostname.includes('youtube.com') || u.hostname === 'youtu.be') return 'youtube';
    return 'unknown';
  } catch { return 'invalid'; }
};
